import React, { PureComponent, PropTypes } from 'react';
import Spinner from 'ak-spinner';
import ComponentDetailVersionDropdown from '../../components/ComponentDetailPage/ComponentDetailVersionDropdown';

export default class ComponentDetailPage extends PureComponent {
  static propTypes = {
    componentName: PropTypes.string,
    isLoadingData: PropTypes.bool,
    defaultSelectedVersion: PropTypes.string,
    allVersions: PropTypes.array,
  }

  static defaultProps = {
    allVersions: [],
    isLoadingData: false,
  }

  render() {
    const { componentName } = this.props;
    return (
      <div>
        <h2 style={{ display: 'inline-block' }}>{componentName}</h2>
        &nbsp;
        <ComponentDetailVersionDropdown
          componentName={componentName}
          defaultSelectedVersion={this.props.defaultSelectedVersion}
          allVersions={this.props.allVersions}
        />
        &nbsp;
        { this.props.isLoadingData ? <Spinner /> : null }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ComponentDetailPage/ComponentDetailHeader.jsx